// DEPENDENCIES
require('modules/hotel/hotel');
require('modules/room/room');
require('modules/invitation-room/invitation-room');
require('modules/transfer/transfer');
require('modules/invitation-transfer/invitation-transfer');
require('modules/invitation-transfer-event/invitation-transfer-event');

// ROUTES
require('modules/hospitality/routes/hospitality');

// CONTROLLERS
require('modules/hospitality/controllers/hospitality');
require('modules/hospitality/controllers/dashboard');


angular.module('unica_hospitality', [

	'unica_hotel',
	'unica_room',
	'unica_invitation_room',
	'unica_transfer',
	'unica_invitation_transfer',
	'unica_invitation_transfer_event',

	// ROUTES
	'unica_hospitality.hospitality_routes',

	// CONTROLLERS
	'unica_hospitality.hospitality_controllers',

]);